/*
 * @Description:表单计算-逻辑处理
 * @Author: ningjz
 * @Date: 2026-03-21 11:24:11
 * @LastEditTime: 2026-04-18 11:26:52
 *
 * 适用范围
 * 所有填报、审核弹窗
 *
 * 填报页面
 * src/views/qxtbcaiji/component/qxtbxiangqing.vue
 1、引入方法
      import { calculateListDataChange } from '@/utils/formulaCalculation.js';

 2、创建字段
      computeSetList: [], // 计算公式
      computeNeed: [], // 需要被计算的商品-商code数组
      goodsInfosNeed: [] // 需要被计算的商品-code数组

 3、在初次加载数据，遍历第一行加入
      calculateListDataChange(this, result.computesetlist, res[i], i);

 4、在视图 模板中 <comList  传入字段
      :computeSetList="computeSetList"
      :computeNeed="computeNeed"
      :goodsInfosNeed="goodsInfosNeed"

 * 填报页面-列表组件
   src/components/comList/index.vue
  1、接收字段
      computeSetList:{
            type: Array,
            default: () => {
              return [];
            }
        },
      computeNeed:{
            type: Array,
            default: () => {
              return [];
            }
        },
      goodsInfosNeed:{
            type: Array,
            default: () => {
              return [];
            }
        },

 */
import { roundTo } from '@/utils/index.js';
/**
 * @description:
 */
/**
 * @description: 列表初始化，数据处理
 * @return 将计算列置灰、说明列设置为 ‘系统计算结果’
 */
export const calculateListDataChange = (that, computesetlist, item, i) => {
  const _this = that;
  // 第一次渲染遍历数据时，加载计算公式
  if (i == 0) {
    _this.computeNeed = [];
    _this.computeSetList = [];
    _this.goodsInfosNeed = [];
    if (computesetlist) {
      computesetlist.forEach((i) => {
        if (i.computeType == 1) {
          let list = i.goodsInfos.split(',');
          _this.computeNeed.push(i.toGoodsCode);
          _this.computeSetList.push(i);
          list.forEach((j) => {
            _this.goodsInfosNeed.push(j);
          });
        }
      });
    }
  }
  // 每次，给计算结果增加一个说明
  if (_this.computeNeed.includes(item.VarietyCode)) {
    if ('remark' in item) {
      item.remark = '系统计算结果';
    }
    if ('Memo' in item) {
      item.Memo = '系统计算结果';
    }
    if ('ThisPrice' in item && !item.ThisPrice) {
      item.ThisPrice = 0;
    }
    if ('currentPrice' in item && !item.currentPrice) {
      item.currentPrice = 0;
    }
  }
  // console.log(
  //   "_this.computeNeed,_this.computeSetList,_this.goodsInfosNeed,",
  //   _this.computeNeed,
  //   _this.computeSetList,
  //   _this.goodsInfosNeed
  // );
};

// 输入字符后触发计算
export const calculateComputeInfoChange = (that, tableData, row) => {
  const _this = that;
  if (_this.goodsInfosNeed.indexOf(row.VarietyCode) > -1) {
    let checkList = [];
    _this.computeSetList.forEach((i) => {
      if (i.goodsInfos.indexOf(row.VarietyCode) > -1) {
        checkList.push(i);
      }
    });
    checkList.forEach((check) => {
      let list = check.goodsInfos.split(',');
      let convertExp = check.convertExpression;
      tableData.forEach((i) => {
        list.forEach((j) => {
          if (j == i.VarietyCode && i.StationCode == row.StationCode) {
            convertExp = convertExp.replace(new RegExp(i.VarietyCode, 'g'), i.ThisPrice ? i.ThisPrice : 0);
          }
        });
      });
      if (convertExp.indexOf('JCSP') > -1) {
        convertExp = convertExp.replace(/JCSP\d{5}/g, '0');
      }
      let result = '';
      try {
        result = safeNumber(eval(convertExp));
      } catch (error) {}
      tableData.forEach((i) => {
        if (i.VarietyCode == check.toGoodsCode && i.StationCode == row.StationCode) {
          result = roundOffChage(result, i.report_digits ? i.report_digits : 2);
          const ThisPrice = result.toFixed(Number(i.report_digits ? i.report_digits : 2)) + '';
          if (isNaN(Number(ThisPrice)) || ThisPrice <= 0) {
            i.ThisPrice = '0';
          } else {
            i.ThisPrice = ThisPrice;
            if (_this.computeNeed.includes(row.VarietyCode)) {
              if (('remark' in row && row.remark == '系统计算结果') || ('Memo' in row && row.Memo == '系统计算结果')) {
                i.remark = '系统计算结果';
              } else {
                i.remark = '';
              }
            }
          }
        }
      });
    });
  }
  // // 每次，给计算结果增加一个说明
  // console.log("row.VarietyCode", row.VarietyCode);
  // if (_this.computeNeed.includes(row.VarietyCode)) {
  //   console.log("2", 2);
  //   if ("remark" in row) {
  //     row.remark = "系统计算结果";
  //   }
  //   if ("Memo" in row) {
  //     row.Memo = "系统计算结果";
  //   }
  // }
  // 处理计算四舍五入时,js底层的5舍6入
  function roundOffChage(data, setKeepDigits) {
    let result = data;
    let dataArr = String(result).split('.');
    let setKeep = Number(setKeepDigits);
    if (typeof data == 'number' && setKeep && dataArr[1] && dataArr[1].length > setKeep) {
      return roundTo(result, setKeep);
    }
    return Number(result);
  }
};
function safeNumber(value) {
  const num = Number(value);
  return isFinite(num) ? num : 0; //判断是否为合法有限数字
}
